export default __webpack_public_path__ + "static/media/Loading.f53aa23f.gif";